import { useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export default function SuccessModal({onDismiss, success}) {

    const [modalIsVisible, setModalIsVisible] = useState(true);

    const dismiss = function () {
        setModalIsVisible(false);

        if (onDismiss) {
            onDismiss();
        }
    }

    return <Modal show={modalIsVisible} onHide={() => setModalIsVisible(false)} centered>
        <Modal.Header>
            <Modal.Title><i className="fi-check text-success me-2"></i>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p className="mb-3">{success.message}</p>
        </Modal.Body>
        <Modal.Footer>
            <Button size="sm" variant='primary' onClick={dismiss}>Close</Button>
        </Modal.Footer>
    </Modal>
}